import { RxCustomerAPI } from '@driftt/dapper'

export const api = {
  startConversationsRevealTrial(orgId) {
    return RxCustomerAPI
      .post(`/gates/start_clearbit_trial/${orgId}`)
      .checkStatus()
      .retryWithBackoff()
  },
  startDriftIntelRevealTrial(orgId) {
    return RxCustomerAPI
      .post(`/gates/start_drift_intel_trial/${orgId}`)
      .checkStatus()
      .retryWithBackoff()
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/gates/api.js